// extracted by mini-css-extract-plugin
export var displayNone = "_rx-6";
export var imgContainer = "_rx-2";
export var overflowHidden = "_rx-3";
export var productInfoCardButtonContainer = "_rx-5";
export var productTitleText = "_rx-4";
export var rightArrow = "_rx-1";
export var rightArrowContainer = "_rx-0";